import React from 'react';
import PropTypes from 'prop-types';
import CookieConsentController from 'components/ui/cookie-consent/cookie-consent-controller';
import './splash.scss';

const Splash = ({isLoading, splashPageClass, handleGoToGame}) => {
	return (
		<div className={'Splash' + (splashPageClass.length > 0 ? ' Splash--' + splashPageClass : '')}>
			<div 
				className={'Splash-play' + (isLoading ? ' loading' : '')} 
				onClick={() => {handleGoToGame();}}
			/>
			<CookieConsentController />
		</div>				
	);
};

Splash.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	splashPageClass: PropTypes.string.isRequired,
	handleGoToGame: PropTypes.func.isRequired
};

export default Splash;